import React from 'react';
import styled from 'styled-components';
import {SaveState} from '../shared/saveState';
import {SaveStatePill} from './SaveStatePill';

const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 24px;
	border-bottom: 1px solid #e6e8f0;
`;
const AgentName = styled.h1`
	font-size: 20px;
	margin: 0;
`;

interface Props {
	agentName: string | null;
	saveState: SaveState;
}

export function NovaStudioHeader({agentName, saveState}: Props): JSX.Element {
	return (
		<HeaderRow data-cy="nova-studio-header">
			{/* Placeholder copy — not localised yet; must go through the translations workflow. */}
			<AgentName>{agentName ?? 'No agent selected'}</AgentName>
			{agentName !== null && <SaveStatePill saveState={saveState} />}
		</HeaderRow>
	);
}
